module.exports = __webpack_public_path__ + "static/media/turn-off-camera.90dcb0a0.svg";